export const AzureADIntegrationLink =
  'https://docs.uipath.com/automation-suite/{language}/docs/setting-up-the-azure-ad-integration';

export const AzureADIntegrationExceptionsLink =
  'https://docs.uipath.com/automation-suite/{language}/docs/setting-up-the-azure-ad-integration#exception';
